import { Trans } from 'react-i18next';

import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import styled from 'styled-components';

const StyledAlert = styled(Alert)`
    max-width: 1200px;
    margin: 12px auto 0;
`;

const HelpAlert = () => {
    return (
        <StyledAlert style={{ maxWidth: '1200px', margin: '12px auto 0' }} severity='info'>
            <Trans i18nKey='pages.plastic_assessment.tabs.kpi.help'>
                _<AlertTitle>_</AlertTitle>_
                <b>_</b>
            </Trans>
        </StyledAlert>
    );
};

export default HelpAlert;